export default __webpack_public_path__ + "static/media/Template9.1857999a.gif";